module.exports = __webpack_public_path__ + "static/assets/3299cad6fda8c0a3d957a5ea75060677.mp3";